import _get from "lodash/get";
import styled from 'styled-components';
import { transparentize } from 'polished';
import formTheme from '../../styles/formTheme';
var FormSelectOption = styled.option.withConfig({
  displayName: "FormSelectOption",
  componentId: "q2m709-0"
})(["color:", ";&:disabled{color:", ";}"], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.select." + skin + ".optionColor", formTheme.form.select[skin].optionColor);
}, function (_ref2) {
  var theme = _ref2.theme,
      skin = _ref2.skin;
  return transparentize(0.3, _get(theme, "form.select." + skin + ".optionColor", formTheme.form.select[skin].optionColor));
});
export default FormSelectOption;